import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {TermsComponent} from '../terms/terms.component';

const routes: Routes = [
  { path: 'terms', component: TermsComponent, data: { title: 'Terms' } }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  declarations: []
})
export class TermsRoutingModule { }
